// extracted by mini-css-extract-plugin
module.exports = {"support":"TabSupport_support__5XbrP"};